import {css} from 'lit';
export const styles = css`form {
  position: relative;
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  padding: var(--chat-form-padding);
  background-color: var(--chat-form-background);
  border: var(--chat-form-border);
  border-radius: var(--chat-form-border-radius);
}

  form.has-files button[type='submit'] {
      margin-bottom: var(--chat-form-submit-margin-bottom);
    }

.left {
  flex: 1;
  min-width: 1px;
  padding: var(--chat-form-left-padding);
  background-color: var(--chat-form-left-background);
  border: var(--chat-form-left-border);
  border-radius: var(--chat-form-left-border-radius);
}

.left.edit {
    --chat-form-left-background: var(--chat-form-left-edit-background);
    --chat-form-input-background: var(--chat-form-edit-input-background);
  }

section {
  display: flex;
  align-items: center;
}

button[type='submit'] {
  --link-focus-outline-offset: var(--chat-form-submit-outline-offset);

  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--chat-form-submit-width);
  height: var(--chat-form-submit-height);
  margin-left: var(--chat-form-submit-margin-left);
  background-color: var(--chat-form-submit-background);
  color: var(--chat-form-submit-color);
  border-radius: var(--chat-form-submit-border-radius);
  border: var(--chat-form-submit-border);
  font-size: var(--chat-form-submit-font-size);
}

@media (hover: hover) {
    button[type='submit']:hover {
      opacity: 0.7;
    }
  }

button[type='submit']:active {
    opacity: 1;
  }

button[type='submit']:disabled {
    background-color: var(--chat-form-submit-disabled-background);
    cursor: not-allowed;
    opacity: 0.7;
  }

.file {
  display: flex;
  align-items: center;
  align-self: var(--chat-form-file-align);
  height: var(--chat-form-file-height);
  margin-right: var(--chat-form-file-margin);
  font-size: var(--chat-form-file-font-size);
}

.textarea-wrapper {
  display: flex;
  align-items: center;
  flex: 1;
}

slot[name='textarea'] {
  display: block;
  flex: 1 1 auto;
}

textarea {
  --line-height: 22px; /* Must be in pixels */

  width: 100%;
  padding: 0;
  background-color: var(--chat-form-input-background);
  border: none;
  font-size: var(--font-size-base);
  outline: none;
  resize: none;
  line-height: var(--line-height);
}

/* A hidden textarea is used to calculate the height of the real textarea */

.textarea-clone-wrapper {
  z-index: -1;
  position: absolute;
  bottom: 50%;
  left: 50%;
  overflow: hidden;

  /* Don't go below 10px or some browser  */
  width: 10px;
  height: 10px;
}

.exit-btn {
  width: 100%;
  margin-bottom: 8px;
  background-color: transparent;
  border: none;
  color: var(--link-text);
  font-weight: 600;
}

@media (hover: hover) {
    .exit-btn:hover {
      color: var(--link-text-hover);
    }
  }

.exit-btn:active {
    color: var(--link-text-active);
  }

input[type='file'] {
  opacity: 0;
  width: 0;
  height: 0;
  font-size: 1px;
}

input[type='file'].focus-visible + label > ef-icon {
      outline: 1px solid var(--link-focus-outline);
      outline-offset: 2px;
    }

input[type='file'].focus-visible + label > ef-icon {
      outline: 1px solid var(--link-focus-outline);
      outline-offset: 2px;
    }

input[type='file']:focus-visible + label > ef-icon {
      outline: 1px solid var(--link-focus-outline);
      outline-offset: 2px;
    }

@media (hover: hover) {
    input[type='file']:hover + label > ef-icon {
      opacity: 0.7;
    }
  }

input[type='file']:active + label > ef-icon {
    opacity: 1;
  }

.file-preview {
  margin-top: var(--chat-form-files-padding);
  padding-top: var(--chat-form-files-padding);
  border-top: var(--chat-form-files-divider);
  font-size: var(--chat-form-files-font-size);
}

.file-preview span {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
  }

.remove-file-button {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  width: calc(var(--font-size-base) * 1.2);
  height: calc(var(--font-size-base) * 1.2);
  margin-right: var(--chat-form-files-remove-btn-margin);
  padding: 0;
  border: var(--chat-form-files-remove-btn-border);
  border-radius: var(--chat-form-files-remove-btn-border-radius);
  background-color: var(--chat-form-files-remove-btn-background);
  color: var(--chat-form-files-remove-btn-color);
}

@media (hover: hover) {
    .remove-file-button:hover {
      opacity: 0.7;
    }
  }

.remove-file-button:active {
    opacity: 1;
  }
`;
export default styles;
